var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DataTableMain',{attrs:{"datatable":_vm.table,"on-success":_vm.successAction,"items-action":_vm.tableAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }